
import Vue from "vue";
export default Vue.extend({
  name: "DisplayDataInTable",
  props: {
    data: {
      type: Object,
      required: true,
      default: () => {}
    }
  }
});
